<header
  class="sticky top-0 flex w-full bg-white border-gray-200 z-40 dark:border-gray-800 dark:bg-gray-900 xl:border-b">
  <div
    class="flex items-center justify-between grow gap-3 px-3 py-3 border-b border-gray-200 dark:border-gray-800 sm:px-4 xl:border-b-0 xl:px-6 lg:py-4">
    <div class="flex items-center gap-3 sm:gap-4">
      <button
        class="items-center justify-center w-10 h-10 text-gray-500 border border-gray-200 rounded-lg flex dark:border-gray-800 dark:text-gray-400 lg:h-11 lg:w-11"
        [ngClass]="{
          'bg-gray-100 dark:bg-white/[0.03]': isMobileOpen$ | async
        }" (click)="handleToggle()" aria-label="Toggle Sidebar">
        @if (isMobileOpen$ | async) {
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
          <path fill-rule="evenodd" clip-rule="evenodd"
            d="M6.21967 7.28131C5.92678 6.98841 5.92678 6.51354 6.21967 6.22065C6.51256 5.92775 6.98744 5.92775 7.28033 6.22065L11.999 10.9393L16.7176 6.22078C17.0105 5.92789 17.4854 5.92788 17.7782 6.22078C18.0711 6.51367 18.0711 6.98855 17.7782 7.28144L13.0597 12L17.7782 16.7186C18.0711 17.0115 18.0711 17.4863 17.7782 17.7792C17.4854 18.0721 17.0105 18.0721 16.7176 17.7792L11.999 13.0607L7.28033 17.7794C6.98744 18.0722 6.51256 18.0722 6.21967 17.7794C5.92678 17.4865 5.92678 17.0116 6.21967 16.7187L10.9384 12L6.21967 7.28131Z"
            fill="currentColor" />
        </svg>
        } @else {
        <svg width="16" height="12" viewBox="0 0 16 12" fill="none">
          <path fill-rule="evenodd" clip-rule="evenodd"
            d="M0.583252 1C0.583252 0.585788 0.919038 0.25 1.33325 0.25H14.6666C15.0808 0.25 15.4166 0.585786 15.4166 1C15.4166 1.41421 15.0808 1.75 14.6666 1.75L1.33325 1.75C0.919038 1.75 0.583252 1.41422 0.583252 1ZM0.583252 11C0.583252 10.5858 0.919038 10.25 1.33325 10.25L14.6666 10.25C15.0808 10.25 15.4166 10.5858 15.4166 11C15.4166 11.4142 15.0808 11.75 14.6666 11.75L1.33325 11.75C0.919038 11.75 0.583252 11.4142 0.583252 11ZM1.33325 5.25C0.919038 5.25 0.583252 5.58579 0.583252 6C0.583252 6.41421 0.919038 6.75 1.33325 6.75L7.99992 6.75C8.41413 6.75 8.74992 6.41421 8.74992 6C8.74992 5.58579 8.41413 5.25 7.99992 5.25L1.33325 5.25Z"
            fill="currentColor" />
        </svg>
        }
      </button>

      <a routerLink="/all" class="xl:hidden">
        <img src="/images/logo/Safeword-icon.svg" alt="Safeword Logo" class="h-7 w-auto" />
      </a>

      <!-- <div class="hidden xl:block">
        <form>
          <div class="relative">
            <span class="absolute -translate-y-1/2 pointer-events-none left-4 top-1/2">
              <svg class="fill-gray-500 dark:fill-gray-400" width="20" height="20" viewBox="0 0 20 20" fill="none">
                <path fill-rule="evenodd" clip-rule="evenodd"
                  d="M3.04175 9.37363C3.04175 5.87693 5.87711 3.04199 9.37508 3.04199C12.8731 3.04199 15.7084 5.87693 15.7084 9.37363C15.7084 12.8703 12.8731 15.7053 9.37508 15.7053C5.87711 15.7053 3.04175 12.8703 3.04175 9.37363ZM9.37508 1.54199C5.04902 1.54199 1.54175 5.04817 1.54175 9.37363C1.54175 13.6991 5.04902 17.2053 9.37508 17.2053C11.2674 17.2053 13.003 16.5344 14.357 15.4176L17.177 18.238C17.4699 18.5309 17.9448 18.5309 18.2377 18.238C18.5306 17.9451 18.5306 17.4703 18.2377 17.1774L15.418 14.3573C16.5365 13.0033 17.2084 11.2669 17.2084 9.37363C17.2084 5.04817 13.7011 1.54199 9.37508 1.54199Z"
                  fill="" />
              </svg>
            </span>
            <input #searchInput type="text" placeholder="Search or type command..."
              class="dark:bg-dark-900 h-11 w-full rounded-lg border border-gray-200 bg-transparent py-2.5 pl-12 pr-14 text-sm text-gray-800 shadow-theme-xs placeholder:text-gray-400 focus:border-brand-300 focus:outline-hidden focus:ring-3 focus:ring-brand-500/10 dark:border-gray-800 dark:bg-gray-900 dark:bg-white/[0.03] dark:text-white/90 dark:placeholder:text-white/30 dark:focus:border-brand-800 xl:w-[430px]" />
          </div>
        </form>
      </div> -->
    </div>

    <button (click)="toggleApplicationMenu()" data-app-menu-toggle
      class="flex items-center justify-center w-10 h-10 text-gray-700 rounded-xl hover:bg-gray-100 dark:text-gray-400 dark:hover:bg-gray-800 xl:hidden"
      [attr.aria-expanded]="isApplicationMenuOpen" aria-label="Open dashboard menu">
      <svg *ngIf="!isApplicationMenuOpen" width="24" height="24" viewBox="0 0 24 24" fill="none">
        <path d="M4 7H20M4 12H20M4 17H20" stroke="currentColor" stroke-width="2" stroke-linecap="round" />
      </svg>
      <svg *ngIf="isApplicationMenuOpen" width="24" height="24" viewBox="0 0 24 24" fill="none">
        <path d="M6 6L18 18M18 6L6 18" stroke="currentColor" stroke-width="2" stroke-linecap="round" />
      </svg>
    </button>

    <div class="hidden items-center justify-between gap-4 xl:flex">
      <div class="flex items-center gap-2 2xsm:gap-3">
        <div class="relative" *ngIf="(authState$ | async)?.isLoggedIn">
          <app-share-love-menu (createPost)="openPostModal()" (createEvent)="openEventModal()"
              (opened)="onShareMenuOpened()"></app-share-love-menu>
        </div>

        <button *ngIf="(authState$ | async)?.isLoggedIn"
          class="hidden md:flex relative items-center justify-center w-9 h-9 text-gray-500 hover:text-gray-700 dark:text-gray-400 dark:hover:text-gray-200 transition-colors duration-200"
          routerLink="/dashboard/chat" aria-label="Chat">
          <svg width="28" height="28" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M21 11.5a8.38 8.38 0 0 1-.9 3.8 8.5 8.5 0 0 1-7.6 4.7 8.38 8.38 0 0 1-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 0 1-.9-3.8 8.5 8.5 0 0 1 4.7-7.6 8.38 8.38 0 0 1 3.8-.9h.5a8.48 8.48 0 0 1 8 8v.5z"
              stroke="#000000" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
          </svg>
          <span *ngIf="(totalUnreadChat$ | async) as cnt"
            class="absolute -top-1 -right-1 flex items-center justify-center w-5 h-5 bg-[#D31148] text-white text-[12px] font-bold rounded-full leading-none">
            {{ cnt > 99 ? '99+' : cnt }}
          </span>
        </button>
        <button (click)="toggleNotificationPanel()" *ngIf="(authState$ | async)?.isLoggedIn"
          class="relative flex items-center justify-center w-9 h-9 text-gray-500 hover:text-gray-700 dark:text-gray-400 dark:hover:text-gray-200 transition-colors duration-200"
          aria-label="Notifications">
          <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M10.9134 24.5007C11.7361 25.2267 12.8167 25.6673 14.0002 25.6673C15.1837 25.6673 16.2644 25.2267 17.087 24.5007M21.0002 9.33398C21.0002 7.47747 20.2627 5.69699 18.95 4.38424C17.6372 3.07148 15.8567 2.33398 14.0002 2.33398C12.1437 2.33398 10.3632 3.07148 9.05048 4.38424C7.73772 5.69699 7.00023 7.47747 7.00023 9.33398C7.00023 12.9392 6.09077 15.4076 5.07483 17.0403C4.21787 18.4175 3.78939 19.1061 3.8051 19.2982C3.8225 19.5109 3.86756 19.592 4.03896 19.7192C4.19376 19.834 4.89158 19.834 6.28722 19.834H21.7132C23.1089 19.834 23.8067 19.834 23.9615 19.7192C24.1329 19.592 24.178 19.5109 24.1953 19.2982C24.2111 19.1061 23.7826 18.4175 22.9256 17.0403C21.9097 15.4076 21.0002 12.9392 21.0002 9.33398Z"
              stroke="#000000" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
          </svg>
          <span *ngIf="(unreadNotifCount$ | async) as cnt"
            class="absolute -top-1 -right-1 flex items-center justify-center w-5 h-5 bg-[#D31148] text-white text-[12px] font-bold rounded-full leading-none">
            {{ cnt > 99 ? '99+' : cnt }}
          </span>
        </button>
      </div>
      <div class="flex items-center space-x-4" *ngIf="authLoaded">
        <ng-container *ngIf="(authState$ | async) as auth">
          <ng-container *ngIf="auth.isLoggedIn; else guest">
            <app-user-dashboard-dropdown [user]="auth.user" (dropdownOpened)="closeDropdown()"></app-user-dashboard-dropdown>
          </ng-container>
        </ng-container>

        <ng-template #guest>
          <div class="flex items-center space-x-3">
            <a routerLink="/login"
              class="px-4 py-2 text-white bg-brand-500 hover:bg-brand-500 rounded-md font-medium transition-colors duration-200">
              Sign In
            </a>
            <span class="text-gray-400">|</span>
            <a routerLink="/register"
              class="px-4 py-2 border border-brand-500 text-brand-500 hover:bg-[#FEE0E0] rounded-md font-medium transition-colors duration-200">
              Sign Up
            </a>
          </div>
        </ng-template>
      </div>
    </div>
  </div>
</header>

<div *ngIf="isApplicationMenuOpen" class="fixed inset-0 z-50 xl:hidden">
  <button type="button" (click)="closeApplicationMenu()" aria-label="Close navigation menu"
    class="absolute inset-0 bg-black/45 backdrop-blur-[2px]"></button>

  <aside data-app-menu-panel
    class="absolute inset-y-0 right-0 flex w-full max-w-[22rem] flex-col bg-white shadow-2xl dark:bg-gray-900">
    <div class="flex items-center border-b border-gray-200 px-5 py-4 dark:border-gray-800"
      style="justify-content: right;">
      <button type="button" (click)="closeApplicationMenu()"
        class="flex h-10 w-10 items-center justify-center rounded-xl text-gray-500 transition-colors hover:bg-gray-100 hover:text-gray-700 dark:hover:bg-gray-800 dark:hover:text-white"
        aria-label="Close menu">
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
          <path d="M6 6L18 18M18 6L6 18" stroke="currentColor" stroke-width="2" stroke-linecap="round" />
        </svg>
      </button>
    </div>

    <div class="flex-1 overflow-y-auto px-5 py-5">
      <nav *ngIf="currentUrl !== '/profile'" class="space-y-2">
        <p class="mb-3 text-xs font-semibold uppercase tracking-[0.2em] text-gray-400">Pages</p>
        <a *ngIf="!(authState$ | async)?.isLoggedIn" routerLink="/" (click)="closeApplicationMenu()"
          class="flex items-center justify-between rounded-2xl border border-gray-200 px-4 py-3 text-sm font-semibold text-gray-700 transition-colors hover:border-[#D31148] hover:bg-rose-50 hover:text-[#D31148]"
          routerLinkActive="border-[#D31148] bg-rose-50 text-[#D31148]" [routerLinkActiveOptions]="{ exact: true }">
          <span>Home</span>
          <span>&rsaquo;</span>
        </a>
        <a routerLink="/all" (click)="closeApplicationMenu()"
          class="flex items-center justify-between rounded-2xl border border-gray-200 px-4 py-3 text-sm font-semibold text-gray-700 transition-colors hover:border-[#D31148] hover:bg-rose-50 hover:text-[#D31148]"
          routerLinkActive="border-[#D31148] bg-rose-50 text-[#D31148]" [routerLinkActiveOptions]="{ exact: true }">
          <span>All</span>
          <span>&rsaquo;</span>
        </a>
        <!-- <a routerLink="/shop" (click)="closeApplicationMenu()"
          class="flex items-center justify-between rounded-2xl border border-gray-200 px-4 py-3 text-sm font-semibold text-gray-700 transition-colors hover:border-[#D31148] hover:bg-rose-50 hover:text-[#D31148]"
          routerLinkActive="border-[#D31148] bg-rose-50 text-[#D31148]" [routerLinkActiveOptions]="{ exact: true }">
          <span>Shop</span>
          <span>&rsaquo;</span>
        </a> -->
        <a routerLink="/events" (click)="closeApplicationMenu()"
          class="flex items-center justify-between rounded-2xl border border-gray-200 px-4 py-3 text-sm font-semibold text-gray-700 transition-colors hover:border-[#D31148] hover:bg-rose-50 hover:text-[#D31148]"
          routerLinkActive="border-[#D31148] bg-rose-50 text-[#D31148]" [routerLinkActiveOptions]="{ exact: true }">
          <span>Events</span>
          <span>&rsaquo;</span>
        </a>
        <a routerLink="/blogs" (click)="closeApplicationMenu()"
          class="flex items-center justify-between rounded-2xl border border-gray-200 px-4 py-3 text-sm font-semibold text-gray-700 transition-colors hover:border-[#D31148] hover:bg-rose-50 hover:text-[#D31148]"
          routerLinkActive="border-[#D31148] bg-rose-50 text-[#D31148]" [routerLinkActiveOptions]="{ exact: true }">
          <span>Blogs</span>
          <span>&rsaquo;</span>
        </a>
        <a routerLink="/posts" (click)="closeApplicationMenu()"
          class="flex items-center justify-between rounded-2xl border border-gray-200 px-4 py-3 text-sm font-semibold text-gray-700 transition-colors hover:border-[#D31148] hover:bg-rose-50 hover:text-[#D31148]"
          routerLinkActive="border-[#D31148] bg-rose-50 text-[#D31148]" [routerLinkActiveOptions]="{ exact: true }">
          <span>Posts</span>
          <span>&rsaquo;</span>
        </a>
      </nav>

      <div *ngIf="(authState$ | async)?.isLoggedIn" class="mt-6">
        <p class="mb-3 text-xs font-semibold uppercase tracking-[0.2em] text-gray-400">Create</p>
        <div class="grid grid-cols-1 gap-3">
          <button type="button" (click)="openPostModal()"
            class="flex items-center justify-center rounded-2xl bg-[#D31148] px-4 py-3 text-sm font-semibold text-white transition-colors hover:bg-[#b80e3d]">
            Create post
          </button>
          <a routerLink="/blog/create" (click)="closeApplicationMenu()"
            class="flex items-center justify-center rounded-2xl border border-[#D31148] px-4 py-3 text-sm font-semibold text-[#D31148] transition-colors hover:bg-rose-50">
            Create blog
          </a>
          <button type="button" (click)="openEventModal()"
            class="flex items-center justify-center rounded-2xl border border-gray-200 px-4 py-3 text-sm font-semibold text-gray-700 transition-colors hover:border-[#D31148] hover:bg-rose-50 hover:text-[#D31148]">
            Create event
          </button>
        </div>
      </div>

      <div *ngIf="(authState$ | async)?.isLoggedIn" class="mt-6">
        <p class="mb-3 text-xs font-semibold uppercase tracking-[0.2em] text-gray-400">Connections</p>
        <div class="grid grid-cols-3 gap-3">
          <a routerLink="/dashboard/chat" (click)="closeApplicationMenu()"
            class="relative flex h-20 items-center justify-center rounded-2xl border border-gray-200 text-gray-700 transition-colors hover:border-[#D31148] hover:bg-rose-50 hover:text-[#D31148]"
            aria-label="Chat">
            <svg width="26" height="26" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M21 15a4 4 0 0 1-4 4H8l-5 3V7a4 4 0 0 1 4-4h10a4 4 0 0 1 4 4v8z" stroke="currentColor"
                stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
            </svg>
            <span *ngIf="(totalUnreadChat$ | async) as cnt"
              class="absolute top-4 right-6 flex min-w-5 h-5 items-center justify-center rounded-full bg-[#D31148] px-1.5 text-[11px] font-bold text-white leading-none">
              {{ cnt > 99 ? '99+' : cnt }}
            </span>
          </a>

          <!-- <button type="button"
            class="relative flex h-20 items-center justify-center rounded-2xl border border-gray-200 text-gray-700 transition-colors hover:border-[#D31148] hover:bg-rose-50 hover:text-[#D31148]"
            aria-label="Cart">
            <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M2.3335 2.33398H3.85735C4.14438 2.33398 4.28789 2.33398 4.40338 2.38676C4.50515 2.43328 4.5914 2.50808 4.65184 2.60225C4.72042 2.70912 4.74072 2.85119 4.78131 3.13532L5.3335 7.00065M5.3335 7.00065L6.5607 16.0206C6.71644 17.1653 6.7943 17.7376 7.06795 18.1684C7.30907 18.548 7.65476 18.8498 8.06341 19.0376C8.52717 19.2507 9.10476 19.2507 10.26 19.2507H20.2442C21.3438 19.2507 21.8936 19.2507 22.3429 19.0528C22.7391 18.8784 23.079 18.5971 23.3245 18.2406C23.6029 17.8362 23.7058 17.2961 23.9115 16.2159L25.4558 8.10862C25.5282 7.72843 25.5644 7.53833 25.5119 7.38973C25.4659 7.25938 25.3751 7.14962 25.2556 7.08001C25.1195 7.00065 24.926 7.00065 24.5389 7.00065H5.3335ZM11.6668 24.5007C11.6668 25.145 11.1445 25.6673 10.5002 25.6673C9.85583 25.6673 9.3335 25.145 9.3335 24.5007C9.3335 23.8563 9.85583 23.334 10.5002 23.334C11.1445 23.334 11.6668 23.8563 11.6668 24.5007ZM21.0002 24.5007C21.0002 25.145 20.4778 25.6673 19.8335 25.6673C19.1892 25.6673 18.6668 25.145 18.6668 24.5007C18.6668 23.8563 19.1892 23.334 19.8335 23.334C20.4778 23.334 21.0002 23.8563 21.0002 24.5007Z"
                stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
            </svg>
            <span
              class="absolute top-4 right-6 flex min-w-5 h-5 items-center justify-center rounded-full bg-[#D31148] px-1.5 text-[11px] font-bold text-white leading-none">
              4
            </span>
          </button> -->

          <button type="button" (click)="toggleNotificationPanel(); closeApplicationMenu()"
            class="relative flex h-20 items-center justify-center rounded-2xl border border-gray-200 text-gray-700 transition-colors hover:border-[#D31148] hover:bg-rose-50 hover:text-[#D31148]"
            aria-label="Notifications">
            <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M10.9134 24.5007C11.7361 25.2267 12.8167 25.6673 14.0002 25.6673C15.1837 25.6673 16.2644 25.2267 17.087 24.5007M21.0002 9.33398C21.0002 7.47747 20.2627 5.69699 18.95 4.38424C17.6372 3.07148 15.8567 2.33398 14.0002 2.33398C12.1437 2.33398 10.3632 3.07148 9.05048 4.38424C7.73772 5.69699 7.00023 7.47747 7.00023 9.33398C7.00023 12.9392 6.09077 15.4076 5.07483 17.0403C4.21787 18.4175 3.78939 19.1061 3.8051 19.2982C3.8225 19.5109 3.86756 19.592 4.03896 19.7192C4.19376 19.834 4.89158 19.834 6.28722 19.834H21.7132C23.1089 19.834 23.8067 19.834 23.9615 19.7192C24.1329 19.592 24.178 19.5109 24.1953 19.2982C24.2111 19.1061 23.7826 18.4175 22.9256 17.0403C21.9097 15.4076 21.0002 12.9392 21.0002 9.33398Z"
                stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
            </svg>
            <span *ngIf="(unreadNotifCount$ | async) as cnt"
              class="absolute top-4 right-6 flex min-w-5 h-5 items-center justify-center rounded-full bg-[#D31148] px-1.5 text-[11px] font-bold text-white leading-none">
              {{ cnt > 99 ? '99+' : cnt }}
            </span>
          </button>
        </div>
      </div>

      <div class="mt-6 border-t border-gray-200 pt-5 dark:border-gray-800" *ngIf="authLoaded">
        <ng-container *ngIf="(authState$ | async) as auth">

          <!-- ── LOGGED IN ── -->
          <ng-container *ngIf="auth.isLoggedIn; else mobileGuest">
            <p class="mb-3 text-xs font-semibold uppercase tracking-[0.2em] text-gray-400">Account</p>

            <div class="rounded-2xl border border-gray-200 bg-gray-50 p-4">

              <div class="flex items-center gap-3 mb-4">
                <div class="relative flex-shrink-0">
                  <img *ngIf="auth.user?.profileImage?.urlSmall || auth.user?.profileImage?.urlMedium"
                    [src]="auth.user?.profileImage?.urlSmall || auth.user?.profileImage?.urlMedium"
                    [alt]="auth.user?.displayName"
                    class="h-12 w-12 rounded-full object-cover border-2 border-white shadow-sm" />
                  <div *ngIf="!auth.user?.profileImage?.urlSmall && !auth.user?.profileImage?.urlMedium"
                    class="h-12 w-12 rounded-full bg-[#FFD4E0] border-2 border-white shadow-sm flex items-center justify-center">
                    <span class="text-lg font-bold text-[#D31148]">
                      {{ (auth.user?.displayName || auth.user?.userName || 'U').charAt(0).toUpperCase() }}
                    </span>
                  </div>
                </div>

                <div class="flex-1 min-w-0">
                  <p class="text-sm font-bold text-gray-900 truncate">{{ auth.user?.displayName || auth.user?.userName
                    }}</p>
                  <p class="text-xs text-gray-500 truncate">{{ auth.user?.email }}</p>
                </div>
              </div>

              <button type="button" (click)="signOut(); closeApplicationMenu()"
                class="mt-3 flex w-full items-center justify-center gap-2 rounded-xl border border-red-200 bg-red-50 px-4 py-2.5 text-sm font-semibold text-red-600 transition-colors hover:bg-red-100 active:scale-[0.98]">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
                  <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4" stroke="currentColor" stroke-width="2"
                    stroke-linecap="round" />
                  <polyline points="16 17 21 12 16 7" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                    stroke-linejoin="round" />
                  <line x1="21" y1="12" x2="9" y2="12" stroke="currentColor" stroke-width="2" stroke-linecap="round" />
                </svg>
                Sign Out
              </button>

            </div>
          </ng-container>

          <!-- ── GUEST ── -->
          <ng-template #mobileGuest>
            <div class="grid grid-cols-1 gap-3">
              <a routerLink="/login" (click)="closeApplicationMenu()"
                class="flex items-center justify-center rounded-2xl bg-brand-500 px-4 py-3 text-sm font-semibold text-white transition-colors hover:bg-brand-600">
                Sign In
              </a>
              <a routerLink="/register" (click)="closeApplicationMenu()"
                class="flex items-center justify-center rounded-2xl border border-brand-500 px-4 py-3 text-sm font-semibold text-brand-500 transition-colors hover:bg-[#FEE0E0]">
                Sign Up
              </a>
            </div>
          </ng-template>

        </ng-container>
      </div>
    </div>
  </aside>
</div>

<app-notification [isOpen]="isNotificationPanelOpen" (closed)="isNotificationPanelOpen = false"></app-notification>

<!-- Create post / Create event dialogs — one shared copy, also used by the main app header. -->
<app-create-content-modals></app-create-content-modals>
